












import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Ellipsis extends Vue {
  @Prop({ required: true }) text: string;

  @Prop({ default: 5 }) maxLength: number;

  get fullText(): string {
    return this.text;
  }

  get displayText(): string {
    if (this.text.length > this.maxLength!) {
      return this.text.slice(0, this.maxLength!) + '...';
    }
    return this.text;
  }
}
